import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";
import { B2bStatsCardProps } from "@/services/organizationsApi";

const ROLE_LABELS: Record<string, string> = {
  OrgAdmin: "Admins",
  OrgUser: "Membres",
  PendingUser: "En attente",
};

const chartConfig: ChartConfig = {
  count: { label: "Membres", color: "hsl(var(--chart-1))" },
};

export function B2bRolesBarCard({ stats, loading, error }: B2bStatsCardProps) {
  const chartData = (stats?.structure.roles ?? []).map((r) => ({
    name: ROLE_LABELS[r.role] || r.role,
    count: r.count,
  }));

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">Membres par rôle</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        ) : error ? (
          <div className="text-sm text-red-600">{error}</div>
        ) : chartData.length === 0 ? (
          <div className="text-sm text-muted-foreground">Aucun membre</div>
        ) : (
          <ChartContainer config={chartConfig} className="max-h-[250px]">
            <BarChart data={chartData}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="name" tickLine={false} axisLine={false} />
              <YAxis tickLine={false} axisLine={false} allowDecimals={false} />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Bar
                dataKey="count"
                fill="var(--color-count)"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}
